
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class DismantlingItemsGrid extends Serenity.EntityGrid<DismantlingItemsRow, any> {
        protected getColumnsKey() { return 'Production.DismantlingItems'; }
        protected getDialogType() { return DismantlingItemsDialog; }
        protected getIdProperty() { return DismantlingItemsRow.idProperty; }
        protected getInsertPermission() { return DismantlingItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return DismantlingItemsRow.localTextPrefix; }
        protected getService() { return DismantlingItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}